export default __webpack_public_path__ + "static/media/Tasset of Brutal Carnage.bf049931.jpg";